import { Component, Input, OnInit } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationService } from '../../services/notification.service';
import { FileDataService, IFileInfo } from '../../services/file-data.service';

@Component({
  selector: 'renci-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.css']
})
export class FilePreviewComponent implements OnInit {

  @Input()
  public file: IFileInfo;

  public data: any;
  public progressText = 'Loading...';
  public progressValue = 0;

  constructor(
    private modalService: NgbModal,
    private notificationService: NotificationService,
    private dataService: FileDataService) { }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content, {
      size: 'lg'
    });

    this.dataService.downloadFile(this.file.fileId)
      .subscribe((result) => {
        if (result.type === HttpEventType.DownloadProgress) {
          this.progressValue = (result.loaded / result.total) * 100;
        } else if (result.type === HttpEventType.Response) {
          const fileReader = new FileReader();
          fileReader.onload = (event: Event) => {
            this.data = {
              data: new Uint8Array((event.target as any).result)
            };
            this.progressText = 'Loaded.';
          };

          fileReader.readAsArrayBuffer(result.body as Blob);
        }
      },
        error => {
          this.notificationService.error(`Failed to preview ${this.file.fileName} file.`);
        });
  }
}
